import {Hub} from 'yougile-model'
import {Sync} from '@client/sync'
import {useSyncEventUpdateEffect} from '@containers/hooks'
import {TaskChatProxyService} from './proxies/task-chat-proxy'

export interface IChatSettings {
  showReadSystemMessages: boolean
}

const DEFAULT_SETTINGS: IChatSettings = {
  showReadSystemMessages: false
}

export class ChatSettings {
  static useUpdateEffect(): void {
    const settingsHub = this.getSettingsHub()
    useSyncEventUpdateEffect('custom', {
      debounceTime: 50,
      filter: settingsHub.companyId,
      companyId: settingsHub.companyId
    })
  }

  static getSettingsHub(): Hub {
    const box = Sync.getProfile()
    if (!box) {
      throw new Error('Profile box not found')
    }

    const hub = box.getHub(box.companyId)
    if (!hub) {
      throw new Error('Profile hub not found')
    }

    return hub
  }

  static getSettings(): IChatSettings {
    const hub = this.getSettingsHub()
    const settings = hub.data.chatSettings
    if (!settings) {
      return DEFAULT_SETTINGS
    }

    return settings
  }

  static setSettings(settings: Partial<IChatSettings>): void {
    const hub = this.getSettingsHub()
    hub.data.chatSettings = {
      ...this.getSettings(),
      ...settings
    }
    hub.commit()
    TaskChatProxyService.deleteCache()
  }
}
